/**
 * User Interaction Service
 * 
 * API calls for credential storage and interaction responses.
 */

import apiClient from './apiClient';
import { CredentialData, InteractionRequest, InteractionResponse } from '../types/userInteraction';

/**
 * Store platform credentials for organization
 */
export const storeCredentials = async (
  platformId: number,
  credentials: CredentialData
): Promise<InteractionResponse> => {
  const response = await apiClient.post<InteractionResponse>(
    '/api/store-platform-credentials/',
    {
      platform_id: platformId,
      credentials: credentials
    }
  );
  
  return response.data;
};

/**
 * Respond to interaction request (MFA, auth code, etc.)
 */
export const respondToInteraction = async (
  requestUuid: string,
  responseData: CredentialData
): Promise<InteractionResponse> => {
  const response = await apiClient.post<InteractionResponse>(
    `/api/interaction-requests/${requestUuid}/respond/`,
    {
      response_data: responseData
    }
  );
  
  return response.data;
};

/**
 * Get pending interaction requests for a job group
 */
export const getPendingRequests = async (
  jobGroupId: number
): Promise<InteractionRequest[]> => {
  const response = await apiClient.get<{ requests: InteractionRequest[] }>(
    `/api/interaction-requests/pending/${jobGroupId}/`
  );
  
  return response.data.requests;
};
